import React from "react";

const STEPS = [
  { emoji: "1️⃣", title: "Submit Requirements", text: "Bring complete requirements to our agency office at Don Gil, Capitol Site, Cebu City." },
  { emoji: "2️⃣", title: "Medical Exam", text: "After submission, the agency will instruct you to undergo a medical check-up." },
  { emoji: "3️⃣", title: "Family Briefing", text: "A short orientation/briefing is conducted for parents or spouse." },
  { emoji: "4️⃣", title: "Interview", text: "Attend the scheduled interview. If you pass, you proceed to schooling." },
  { emoji: "5️⃣", title: "Japan Language Schooling", text: "Successful applicants are enrolled in FREE Japan Language Schooling (4–5 months). Personal expenses are not covered, no allowance — free tuition only." },
  { emoji: "6️⃣", title: "Final Medical & Compliance", text: "Secure any additional medical certificates and requirements." },
  { emoji: "7️⃣", title: "Deployment to Japan", text: "Once cleared, you will be scheduled for your flight to Japan. ✈️ Ticket cost is covered by the employer." }
];

export default function ApplicationProcessTimeline() {
  return (
    <section className="card mb-24">
      <h2 className="section-title" style={{ marginBottom: 4 }}>📝 Application Process</h2>
      <p className="text-muted mb-16" style={{ fontSize: 13 }}>Golden Gateway Agency — here's what happens after you request your endorsement.</p>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {STEPS.map((s, i) => (
          <div key={i} style={{ display: "flex", gap: 14, padding: "12px 4px", borderBottom: i < STEPS.length - 1 ? "1px solid var(--ink-100)" : "none" }}>
            <div style={{ fontSize: 22, flexShrink: 0, lineHeight: 1.4 }}>{s.emoji}</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "var(--ink-900)" }}>{s.title}</div>
              <div style={{ fontSize: 13, color: "var(--ink-500)", marginTop: 2, lineHeight: 1.5 }}>{s.text}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
